import { Button, Modal } from "react-bootstrap";

const DeleteProjectModal = ({ show, handleClose, project }) => {
  if (!project) return null;

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center p-4">
        <h5 className="mb-3">Delete Project</h5>
        <p>
          Are you sure you want to delete <b>{project.name}</b>?
        </p>

        <div className="d-flex justify-content-center gap-2 mt-3">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger">
            Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default DeleteProjectModal;